(function () {
  const MODAL_SELECTOR = '.quick-sku-modal';
  const ACTIVE_CLASS = 'is-active';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    }
    const amount = (Number(cents || 0) / 100).toFixed(2);
    return `$${amount}`;
  }

  function getModal(element) {
    return element?.closest?.(MODAL_SELECTOR);
  }

  function lockBodyIfNeeded() {
    const hasOpenModal = Boolean(document.querySelector(`${MODAL_SELECTOR}.${ACTIVE_CLASS}`));
    document.body.classList.toggle('quick-sku-modal-open', hasOpenModal);
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove(ACTIVE_CLASS);
    modal.removeAttribute('open');
    modal.setAttribute('aria-hidden', 'true');
    lockBodyIfNeeded();
  }

  function closeOtherModals(except) {
    document.querySelectorAll(`${MODAL_SELECTOR}.${ACTIVE_CLASS}`).forEach((modal) => {
      if (modal !== except) closeModal(modal);
    });
  }

  function openModal(modal) {
    if (!modal) return;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    closeOtherModals(modal);
    modal.classList.add(ACTIVE_CLASS);
    modal.setAttribute('open', '');
    modal.removeAttribute('aria-hidden');
    lockBodyIfNeeded();
    updateModal(modal);
    const firstInput = modal.querySelector('[data-quick-sku-input]:not(:disabled)');
    setTimeout(() => firstInput?.focus?.(), 80);
  }

  function getRows(modal) {
    return Array.from(modal.querySelectorAll('[data-quick-sku-row]'));
  }

  function normalizeQty(value) {
    const qty = parseInt(value, 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 0;
  }

  function setRowQty(row, qty) {
    const input = row.querySelector('[data-quick-sku-input]');
    if (!input || input.disabled) return;
    input.value = String(Math.max(0, qty));
    updateModal(getModal(row));
  }

  function updateModal(modal) {
    if (!modal) return;
    let totalQty = 0;
    let totalCents = 0;
    getRows(modal).forEach((row) => {
      const input = row.querySelector('[data-quick-sku-input]');
      const qty = normalizeQty(input?.value || 0);
      const price = Number(row.dataset.price || 0);
      const rowTotal = qty * price;
      totalQty += qty;
      totalCents += rowTotal;
      const rowTotalEl = row.querySelector('[data-quick-sku-row-total]');
      if (rowTotalEl) rowTotalEl.textContent = formatMoney(rowTotal);
      const minus = row.querySelector('[data-quick-sku-minus]');
      if (minus) minus.disabled = qty <= 0 || input?.disabled;
    });
    const countEl = modal.querySelector('[data-quick-sku-count]');
    const totalEl = modal.querySelector('[data-quick-sku-total]');
    const addButton = modal.querySelector('[data-quick-sku-add]');
    if (countEl) countEl.textContent = `${totalQty} selected`;
    if (totalEl) totalEl.textContent = formatMoney(totalCents);
    if (addButton) addButton.disabled = totalQty <= 0;
  }

  async function refreshCartIcon() {
    try {
      const response = await fetch(`${window.location.pathname}?sections=cart-icon-bubble`, {
        headers: { Accept: 'application/json' }
      });
      const sections = await response.json();
      if (sections['cart-icon-bubble']) {
        const target = document.getElementById('cart-icon-bubble');
        if (target) target.innerHTML = sections['cart-icon-bubble'];
      }
    } catch (error) {
      // Cart icon refresh is best-effort only.
    }
  }

  async function addSelected(modal, button) {
    const items = getRows(modal)
      .map((row) => ({
        id: Number(row.dataset.variantId),
        quantity: normalizeQty(row.querySelector('[data-quick-sku-input]')?.value || 0)
      }))
      .filter((item) => item.id && item.quantity > 0);

    if (!items.length || button.disabled) return;

    const originalText = button.textContent;
    button.disabled = true;
    button.classList.add('loading');
    button.textContent = 'Adding...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error(await response.text());
      getRows(modal).forEach((row) => {
        const input = row.querySelector('[data-quick-sku-input]');
        if (input && !input.disabled) input.value = '0';
      });
      updateModal(modal);
      await refreshCartIcon();
      if (window.PUB_SUB_EVENTS?.cartUpdate && typeof window.publish === 'function') {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'quick-sku-list' });
      }
      button.textContent = 'Added';
      setTimeout(() => {
        button.textContent = originalText;
        updateModal(modal);
      }, 1200);
    } catch (error) {
      console.error('[quick-sku-list] add failed', error);
      button.textContent = 'Add failed - try again';
      setTimeout(() => {
        button.textContent = originalText;
        updateModal(modal);
      }, 1800);
    } finally {
      button.classList.remove('loading');
    }
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('modal-opener[data-modal^="#QuickSkuListModal-"]');
    if (opener) {
      const selector = opener.getAttribute('data-modal');
      const modal = selector ? document.querySelector(selector) : null;
      if (modal) {
        event.preventDefault();
        event.stopPropagation();
        openModal(modal);
        return;
      }
    }

    const closeButton = event.target.closest('.quick-sku-modal__close');
    if (closeButton) {
      event.preventDefault();
      closeModal(getModal(closeButton));
      return;
    }

    const modal = getModal(event.target);
    if (modal && event.target === modal) {
      closeModal(modal);
      return;
    }

    const plus = event.target.closest('[data-quick-sku-plus]');
    if (plus) {
      const row = plus.closest('[data-quick-sku-row]');
      const input = row?.querySelector('[data-quick-sku-input]');
      setRowQty(row, normalizeQty(input?.value || 0) + 1);
      return;
    }

    const minus = event.target.closest('[data-quick-sku-minus]');
    if (minus) {
      const row = minus.closest('[data-quick-sku-row]');
      const input = row?.querySelector('[data-quick-sku-input]');
      setRowQty(row, normalizeQty(input?.value || 0) - 1);
      return;
    }

    const addButton = event.target.closest('[data-quick-sku-add]');
    if (addButton) {
      event.preventDefault();
      addSelected(getModal(addButton), addButton);
    }
  }, true);

  document.addEventListener('input', (event) => {
    if (event.target.matches('[data-quick-sku-input]')) {
      event.target.value = String(normalizeQty(event.target.value));
      updateModal(getModal(event.target));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeModal(document.querySelector(`${MODAL_SELECTOR}.${ACTIVE_CLASS}`));
    }
  });
})();
